<template>
	<div id="root-list-matching">
		<b-overlay
				id="asd"
				:show="queryInProgress"
				variant="light"
				opacity="0.5"
				blur="2px"
				rounded="lg"
		><!-- overlay -->
			<b-card id="main-card-list-matching">
				<div class="d-flex">
					<div class="p-2"><h3>Listenabgleich</h3></div>
					<div class="ml-auto p-2">
						<b-btn id="info-modal" size="sm" @click="showInfoModal = !showInfoModal">
							<i class="bi bi-info-lg" style="font-size:1.5em"></i>
						</b-btn>
					</div>
				</div>
				<div>
					<b-form inline class="py-2">
						<label class="mr-2 col-3 text-right">Listen Typ:</label>
						<b-form-select
								v-model="select.listType"
								:options="listTypeOptions"
								size="sm"
								@input="() => {}"
								class="inputsf"
						></b-form-select>
					</b-form>
					<!-- asd -->
					<b-form
							v-show="listRequiresVendorSelectionInput"
							inline
							class="py-2"
					>
						<label class="mr-2 col-3 text-right" for="select-vendors">Lieferanten:</label>
						<multi-select
								id="select-vendors"
								class="mb-2"
								:value="selectedVendorObjects"
								@input="selectedVendorObjects = $event"
								:options="(wantMainVendorOnly ? mainVendorOptions : allVendorOptions)"
								:multiple="true"
								label="text"
								track-by="value"
								:close-on-select="false"
								:searchable="true"
								:select-label="''"
								:deselect-label="''"
								:selected-label="'✓'"
								:object="false"
								placeholder="Suche"
								style="max-height: calc(1.5em + 0.5rem + 2px) !important; font-size: 0.7875rem !important; max-width: 40% !important;"
						>
							<template #selection="{ search, values, isOpen }">
								<div class=" align-items-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-top: 0 !important; ">
								<span
										v-for="option in values"
										:key="option.value"
										class="p-1 position-relative"
										style="font-size: 0.7875rem; font-weight: normal !important;"
								>
									{{ option.text}}
								</span>
								<input
										v-if="isOpen"
										type="text"
										class="border-0 shadow-none"
										style="min-width: 100px; background: transparent;"
								/>
								</div>
							</template>
							<template #singleLabel>
								<span class="d-flex align-items-center"></span>
							</template>
							<template #placeholder>
								<span>Händler</span>
							</template>
							<template v-slot:caret="{ toggle }">
								<div class="multiselect__select p-0" @mousedown.prevent.stop="toggle">
									<span class="d-flex align-items-center justify-content-center"></span>
								</div>
							</template>
							<template v-slot:option="{ option }">
								{{ option.text }}
							</template>
						</multi-select>
						<b-form-checkbox
								class="ml-2"
								v-model="wantAllVendors"
								name="checkbox-1"
								:value="true"
								:unchecked-value="false"
						>alle Lieferanten
						</b-form-checkbox>
						<b-form-checkbox
								class="ml-2"
								v-model="wantMainVendorOnly"
								name="checkbox-1"
								:value="true"
								:unchecked-value="false"
						>nur Hauptlieferanten
						</b-form-checkbox>
					</b-form>
					<b-form v-if="listRequiresDatePickerInput" inline class="py-2">
						<label for="datepicker" class="mr-2 col-3 text-right ">Zeitraum:</label>
						<div id="datepicker" class="d-flex">
							<label for="select-date-range-from" class="mr-2 text-right col-3">von</label>
							<b-form-datepicker
									id="date-range-from"
									class="mb-2 col-6"
									size="sm"
									:state="validateDateRange"
									v-model="dateFrom"
									:date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }">
							</b-form-datepicker>

							<label for="select-date-range-to" class="mr-2 col-3 text-right">bis</label>
							<b-form-datepicker
									id="date-range-to"
									class="mb-2 col-6"
									size="sm"
									:state="validateDateRange"
									v-model="dateTo"
									:date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }">
							</b-form-datepicker>
						</div>
					</b-form>
					<!--if only one date is requiered and not a date range-->
					<b-form v-if="listRequiresSingleDatePickerInput" inline class="py-2">
						<label for="datepicker" class="mr-2 col-3 text-right ">Zeitraum:</label>
						<div id="datepicker" class="d-flex">
							<label for="select-date-range-from" class="mr-2 text-right col-3" style="min-width: 157px">ab dem</label>
							<b-form-datepicker
									id="date-range-from"
									class="mb-2 col-6"
									size="sm"
									:state="validateDateRange"
									v-model="dateFrom"
									:date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }">
							</b-form-datepicker>
						</div>
					</b-form>
					<b-form inline class="py-2">
						<label class="mr-2 col-3 text-right">Barcodes:</label>
						<b-textarea
								rows="18"
								size="sm"
								class="mr-1 inputsf"
								v-model="select.barcodes"
								@input="() => {}"
						/>
					</b-form>
					<div class="py-2">
						<b-button @click="submit()" :disabled="disableSendButton" class="float-right">absenden
							<b-spinner v-if="queryInProgress" variant="light" label="Spinning"></b-spinner>
						</b-button>
					</div>
				</div>
			</b-card>
		</b-overlay>
		<b-overlay
				id="asd"
				:show="requestQueryInProgress"
				variant="light"
				opacity="0.5"
				blur="2px"
				rounded="lg"
				class="mt-3"
		>
			<b-card>
				<div class="d-flex justify-content-between">
					<div class="p-2"><h3>Verlauf</h3></div>
					<div>
						<b-btn variant="secondary" @click="getAllListmatchingRequest">
							<i class="bi bi-arrow-clockwise"></i>
						</b-btn>
					</div>
				</div>
				<b-table
						:items="listMatchingRequest"
						:fields="fields"
						:tbody-tr-class="rowClass"
						sticky-header="200px"
						small
				>
					<template #cell(listType)="row">
						{{ translateListType(row.item.listType) }}
					</template>
					<template #cell(parameterJSON)="row">
						<b-btn
								@click="showListMatchingRequestModal = !showListMatchingRequestModal; selectedListMatchingRequest = row.item"
								:id="'eanAsinListButton'+row.item.id">
							<i class="bi bi-list"></i>
						</b-btn>
					</template>
					<template #cell(action)="row">
						<b-btn @click="download(row.item.id)" :disabled="disableDownloadButton(row.item)">
							<i class="bi bi-download"></i>
						</b-btn>
					</template>
				</b-table>
			</b-card>
		</b-overlay>
		<b-modal v-model="showInfoModal" title="Infos zu den Listenabgleichen">
			<div>
				<ul>
					<li><b>MarketOrderId / Sendungsnummer zu CustomerOrder/Address</b></li>
					Gibt Kunden- und Bestelldaten zu MarketOrderId oder Sendungsnummer aus.<br>
					Benötigt eine einfache Liste von MarketOrderIds oder Sendungsnummern.
					<li><b>Verkaufshäufigkeit</b></li>
					Gibt Verkaufshäufigkeit zu EANs und von den Lieferanten mit Bestand sofern vorhanden.<br>
					Alternativ wird der günstigste mit Bestand ausgegeben.<br>
					Benötigt eine einfache Liste von EANs, eine Auswahl von Lieferanten und Zeitraum Angaben.
					<li><b>LF, EAN Inventory / (Used)</b></li>
					Gibt Bestandsdaten zu EANs aus. Entweder für neuen oder gebrauchten Zustand.<br>
					Benötigt eine Liste mit tab-getrennten Lieferanten-Ids und EANs.
					<li><b>Inventory LF-Auswahl (EAN) / (Used)</b></li>
					Gibt Bestandsdaten zu EANs aus. Entweder für neuen oder gebrauchten Zustand.<br>
					Benötigt eine einfache Liste von EANs und eine Auswahl von Lieferanten.
					<li><b>Günstigster mit / Ohne Bestand</b></li>
					Gibt Bestandsdaten zu EANs aus, welche die günstigste Summe aus Einkaufs- und Versandpreis haben.<br>
					Mit oder ohne Lagerbestand.<br>
					Benötigt eine einfache Liste von EANs und eine Auswahl von Lieferanten.
					<li><b>Günstigster mit / Ohne Bestand (Alle LF)</b></li>
					Funktionsweise wie "Günstigster mit Bestand", jedoch für alle Lieferanten.<br>
					<li><b>Letzter VK-Preis (EAN)</b></li>
					Gibt den letzten Verkaufspreis zu EANs aus. Wahlweise nur für einen, mehrere oder alle Lieferanten.<br>
					Benötigt eine einfache Liste von EANs.<br>
					Wenn kein Lieferant ausgewählt wird, wird automatisch für alle Lieferanten gesucht.
					<li><b>Gewicht (EAN) / Gewicht (ASIN)</b></li>
					Gibt Produktdaten inklusive Gewicht in Kilogramm zu EAN oder ASIN aus.<br>
					Benötigt eine einfache Liste von EANs oder ASINs.
				</ul>
			</div>
			<template #modal-footer>
				<b-button variant="secondary" @click="showInfoModal = false">Schließen</b-button>
			</template>
		</b-modal>
		<b-modal v-model="showListMatchingRequestModal" no-close-on-backdrop id="listMatchingRequestModal">
			<div v-if="selectedListMatchingRequest != null">
				<div v-if="selectedListMatchingRequest?.parameterJSON?.vendorIds?.length > 0">
					<h5>Lieferanten</h5>
					<div v-for="(vendorId, index) in selectedListMatchingRequest.parameterJSON.vendorIds" :key="index">
						<div>{{ vendorId ? getVendorName(vendorId) : " &nbsp;" }}</div>
					</div>
				</div>
				<div v-else>
					- keine Lieferanten -
				</div>
				<p></p>
				<div v-if="selectedListMatchingRequest?.parameterJSON?.date">
					<h5>Zeitraum</h5>
					<div> Von {{ selectedListMatchingRequest?.parameterJSON?.date.from }}
						{{
							selectedListMatchingRequest?.parameterJSON?.date.to ? ' bis ' + selectedListMatchingRequest?.parameterJSON?.date.to : ''
						}}
					</div>
				</div>
				<div v-else>
					- kein Zeitraum -
				</div>
				<p></p>
				<h5>Barcodes</h5>
				<b-form-textarea
						rows="18"
						size="sm"
						class="mr-1 inputsf"
						disabled
						v-model="productIdentifierAsText"
						@input="() => {}">
				</b-form-textarea>
				<div v-if="selectedListMatchingRequest.errorJSON" class="mt-4">
					<h5>Fehlermeldung</h5>
					<div>{{ selectedListMatchingRequest.errorJSON.message }}</div>
					<div v-if="userRole == 'dev'">
						<div>{{ selectedListMatchingRequest.errorJSON.file }} at line {{
								selectedListMatchingRequest.errorJSON.line
							}}
						</div>
						<b-button @click="openStacktraceCollapse = !openStacktraceCollapse" variant="secondary">Stacktrace
							<i :class="['bi', openStacktraceCollapse ? 'bi-chevron-up' : 'bi-chevron-down', 'ml-2']"></i>
						</b-button>
						<b-collapse id="stacktrace-collapse" v-model="openStacktraceCollapse">{{
								selectedListMatchingRequest.errorJSON.trace
							}}
						</b-collapse>
					</div>
				</div>
			</div>
			<template v-slot:modal-footer>
				<b-button variant="primary" @click="$bvModal.hide('listMatchingRequestModal')">Schließen</b-button>
			</template>
		</b-modal>
		<modal-error-component v-model="modalError"></modal-error-component>
	</div>
</template>
<style scoped>
.inputsf {
	min-width: 70% !important;
}

.bg-error {
	background-color: #da5863 !important;
}

</style>
<script>
import 'json2xls-xml';

export default {
	props: ['productCategories'],
	data() {
		return {
			popoverShow: false,
			queryInProgress: false,
			requestQueryInProgress: false,
			j2xls: require('json2xls-xml')({pretty: true}),
			select: {listType: "marketOrderIdToCustomerOrder", barcodes: "", vendorId: null},
			listTypeOptions: [
				{value: "marketOrderIdToCustomerOrder", text: "MarketOrderId zu CustomerOrder/Address"},
				{value: "shippingIdToCustomerOrder", text: "Sendungsnummer zu CustomerOrder/Address"},
				{value: "salesInvoices", text: "Ausgangsrechnungen"},
				{value: "returnApplication", text: "Retourenantrag"},
				{value: "getLastSellingPrice", text: "Letzter VK-Preis (EAN)"},
				{value: "quantityOfSales", text: "Verkaufshäufigkeit (EAN)"},
				{value: "inventoryByEan", text: "LF, EAN Inventory"},
				{value: "inventoryByEanUsed", text: "LF, EAN Inventory (Used)"},
				{value: "inventoryByEanSelectVendor", text: "Inventory LF-Auswahl (EAN)"},
				{value: "inventoryByEanUsedSelectVendor", text: "Inventory LF-Auswahl (EAN, Used)"},
				{value: "cheapestWithStock", text: "Günstigster mit Bestand"},
				{value: "cheapestWithStock_AllVendors", text: "Günstigster mit Bestand (Alle LF)"},
				{value: "cheapestWithoutStock", text: "Günstigster ohne Bestand"},
				{value: "cheapestWithoutStock_AllVendors", text: "Günstigster ohne Bestand (Alle LF)"},
				{value: "weightByEan", text: "Gewicht (EAN)"},
				{value: "weightByAsin", text: "Gewicht (Asin)"},
				{value: "amazonLowestPrice", text: "Amazon niedrigster Preis (EAN)"},
				{value: "getEanByArticleId", text: "Artikel-ID zu EAN"},
				{value: "getBlockerReasonsForAsin", text: "Asin zu Sperrgründen"},
			],
			vendors: null,
			selectedVendorObjects: [],
			selectedVendors: [],
			mainVendors: [],
			currencies: [],
			categoryMap: [],
			dateFrom: null,
			dateTo: null,
			wantAllVendors: false,
			wantMainVendorOnly: false,
			userRole: null,
			fields: [
				{key: 'listType', label: 'Listentyp'},
				{key: 'parameterJSON', label: 'Parameter'},
				{key: 'user', label: 'Benutzer'},
				{key: 'requestedAt', label: 'Anfragenstart'},
				{key: 'completedAt', label: 'Fertigstellung'},
				{key: 'action', label: ''},
			],
			hasShownProductIdentifierLineWarning: false,
			showListMatchingRequestModal: false,
			selectedListMatchingRequest: null,
			listMatchingRequest: [],
			showInfoModal: false,
			openStacktraceCollapse: false,
			tabIsActive: !document.hidden,
			modalError: {
				show: false,
				message: "unpopulated",
				error: "unpopulated",
				title: "unpopulated"
			},
		};
	},
	watch: {
		selectedVendorObjects(newValue) {
			if (newValue && newValue.length > 0) {
				this.selectedVendors = newValue.map(vendor => vendor.value);
			} else {
				this.selectedVendors = [];
			}
		},
		wantAllVendors(newValue) {
			if (newValue === true) {
				this.vendors.forEach(vendor => {
					this.selectedVendors.push(vendor.id);
				})
				this.vendors.forEach(vendor => {
					this.selectedVendorObjects.push({value: vendor.id, text: `${vendor.name} - (${vendor.skuPrefix})`});
				})
			} else {
				this.selectedVendors = [];
				this.selectedVendorObjects = [];
			}
		},
	},
	computed: {
		allVendorOptions: function () {
			if (!this.vendors) return [];
			return this.vendors.map(vendor => {
				return {value: vendor.id, text: `${vendor.name} - (${vendor.skuPrefix})`} //
			});
		},
		mainVendorOptions: function () {
			if (!this.mainVendors) return [];
			if (!this.vendors) return [];
			this.mainVendors = this.vendors.filter(vendor => vendor.mainVendorId === null)
			return this.mainVendors.map(vendor => {
				return {value: vendor.id, text: `${vendor.name} - (${vendor.skuPrefix})`} //
			});
		},
		validateDateRange: function () {
			if (!this.dateFrom || !this.dateTo) return;
			const from = Date.parse(this.dateFrom);
			const to = Date.parse(this.dateTo);
			return from <= to;
		},

		listRequiresVendorSelectionInput() {
			switch (this.select.listType) {
				case "getLastSellingPrice"             :
					return true;
				case "quantityOfSales"                 :
					return true;
				case "inventoryByEanSelectVendor"      :
					return true;
				case "inventoryByEanUsedSelectVendor"  :
					return true;
				case "cheapestWithStock"               :
					return true;
				case "cheapestWithoutStock"            :
					return true;
				case "returnApplication"               :
					return true;
				case "getEanByArticleId"               :
					return true;
				default                               :
					return false;
			}
		},
		listRequiresDatePickerInput() {
			switch (this.select.listType) {
				case "quantityOfSales"                 :
					return true;
				default                                :
					return false;
			}
		},
		listRequiresSingleDatePickerInput() {
			switch (this.select.listType) {
				case "returnApplication"                 :
					return true;
				default                                :
					return false;
			}
		},
		disableSendButton() {
			if (this.select.barcodes.length === 0) return true;
			if (this.listRequiresVendorSelectionInput && this.selectedVendors.length === 0) return true;
			if (this.listRequiresDatePickerInput && (!this.dateFrom && !this.dateTo)) return true;
		},
		productIdentifierAsText() {
			if (!this.selectedListMatchingRequest || !this.selectedListMatchingRequest?.parameterJSON) return '';
			const list = this.selectedListMatchingRequest.parameterJSON.productIdentifier;

			if (!Array.isArray(list)) return '';

			const limit = 100;
			const visibleItems = list.slice(0, limit);
			const remainingCount = list.length - limit;

			let result = '';

			// If array of strings
			if (typeof visibleItems[0] === 'string') {
				result = visibleItems.join('\n');
			} else {
				// Array of objects with dynamic keys
				result = visibleItems.map(item => {
					return Object.values(item).join('\t');
				}).join('\n');
			}

			if (remainingCount > 0) {
				result += `\n... und ${remainingCount} weitere`;
			}

			return result;
		},
	},
	methods: {
		getAllVendors() {
			this.queryInProgress = true;
			axios.get('/vendor/all').then(response => {
				this.queryInProgress = false;
				this.vendors = response.data;
			}).catch(error => {
				this.queryInProgress = false;
				this.showError(error);
				console.error(error);
			});
		},
		getAllListmatchingRequest() {
			console.log("getting all listmatching requests")
			this.requestQueryInProgress = true;
			axios.get('/listmatching/request/all').then(response => {

				this.requestQueryInProgress = false;
				this.listMatchingRequest = response.data.map(lmh => {
					lmh.parameterJSON = JSON.parse(lmh.parameterJSON);
					lmh.errorJSON = JSON.parse(lmh.errorJSON);
					return lmh;
				});
				this.listMatchingRequest = this.listMatchingRequest.sort((a, b) => new Date(b.requestedAt) - new Date(a.requestedAt));
			}).catch(error => {
				this.requestQueryInProgress = false;
				this.showError(error)
				console.error(error);
			});
		},
		getAllCurrencies() {
			this.queryInProgress = true;
			axios.get('/currency/all').then(response => {
				this.queryInProgress = false;
				this.currencies = response.data;
			}).catch(error => {
				this.queryInProgress = false;
				this.showError(error);
				console.error(error);
			});
		},

		//submitAction_getInventory
		//1. Boolean = articleCondition -- true = new / false = used
		//2. Boolean = onStock -- true = only stock.quantity > 0 / false = quantity = 0 / null = quantity does not matter
		//3. Boolean = vendorSelected -- true = vendor(s) were selected via multiselect / false for tab-divided VendorId and Ean
		//4. Boolean = allVendors -- if a list type requires the inventory of all vendors
		//submitAction_getShippingWeight
		//true = with ean / false = with asin
		submit() {
			const text = this.select.barcodes;
			const lineCount = text ? (text.match(/\n/g) || []).length + 1 : 0;

			if (lineCount > 100000) {
				const shouldContinue = window.confirm(
						'Warnung: Der Text enthält mehr als 100.000 Zeilen. Dies kann zu deutlichen Leistungseinbußen führen. Möchten Sie fortfahren?'
				);

				if (!shouldContinue) {
					return;
				}
			}

			switch (this.select.listType) {
				case "marketOrderIdToCustomerOrder"     :
					this.submitAction_marketOrderIdToCustomerOrder();
					break;
				case "shippingIdToCustomerOrder"        :
					this.submitAction_shippingIdToCustomerOrder();
					break;
				case "salesInvoices"                    :
					this.submitAction_salesInvoices();
					break;
				case "quantityOfSales"                  :
					this.submitAction_quantityOfSales();
					break;
				case "getLastSellingPrice"              :
					this.submitAction_getLastSellingPrice();
					break;
				case "inventoryByEan"                   :
					this.submitAction_getInventory(true, null, false, false);
					break;
				case "inventoryByEanUsed"               :
					this.submitAction_getInventory(false, null, false, false);
					break;
				case "inventoryByEanSelectVendor"       :
					this.submitAction_getInventory(true, null, true, false);
					break;
				case "inventoryByEanUsedSelectVendor"   :
					this.submitAction_getInventory(false, null, true, false);
					break;
				case "cheapestWithStock"                :
					this.submitAction_getCheapestStock(true, true, false);
					break;
				case "cheapestWithStock_AllVendors"     :
					this.submitAction_getCheapestStock(true, true, true);
					break;
				case "cheapestWithoutStock"             :
					this.submitAction_getCheapestStock(true, false, false);
					break;
				case "cheapestWithoutStock_AllVendors"  :
					this.submitAction_getCheapestStock(true, false, true);
					break;
				case "weightByEan"                      :
					this.submitAction_getShippingWeight(true);
					break;
				case "weightByAsin"                     :
					this.submitAction_getShippingWeight(false);
					break;
				case "amazonLowestPrice"                :
					this.submitAction_amazonLowestPrice();
					break;
				case "returnApplication"                :
					this.submitAction_ReturnApplication();
					break;
				case "getEanByArticleId"                :
					this.submitAction_getEanByArticleId();
					break;
				case "getBlockerReasonsForAsin"            :
					this.submitAction_getBlockerReasonsForAsin();
					break;
				default                                 :
					alert(`unknown listType action: ${this.select.listType}`);
			}
		},
		download(listMatchingRequestId) {
			axios.get('/listmatching/request/' + listMatchingRequestId).then(response => {
				switch (response.data.listType) {
					case "marketOrderIdToCustomerOrder"     :
						this.downloadAction_marketOrderIdToCustomerOrder(response.data);
						break;
					case "shippingIdToCustomerOrder"        :
						this.downloadAction_shippingIdToCustomerOrder(response.data);
						break;
					case "salesInvoices"                    :
						this.downloadAction_salesInvoices(response.data);
						break;
					case "quantityOfSales"                  :
						this.downloadAction_quantityOfSales(response.data);
						break;
					case "getLastSellingPrice"              :
						this.downloadAction_getLastSellingPrice(response.data);
						break;
					case "inventoryByEan"                   :
						this.downloadAction_getInventory(response.data);
						break;
					case "inventoryByEanUsed"               :
						this.downloadAction_getInventory(response.data);
						break;
					case "inventoryByEanSelectVendor"       :
						this.downloadAction_getInventory(response.data);
						break;
					case "inventoryByEanUsedSelectVendor"   :
						this.downloadAction_getInventory(response.data);
						break;
					case "cheapestWithStock"                :
						this.downloadAction_getCheapestStock(response.data);
						break;
					case "cheapestWithStock_AllVendors"     :
						this.downloadAction_getCheapestStock(response.data);
						break;
					case "cheapestWithoutStock"             :
						this.downloadAction_getCheapestStock(response.data);
						break;
					case "cheapestWithoutStock_AllVendors"  :
						this.downloadAction_getCheapestStock(response.data);
						break;
					case "weightByEan"                      :
						this.downloadAction_getShippingWeight(response.data);
						break;
					case "weightByAsin"                     :
						this.downloadAction_getShippingWeight(response.data);
						break;
					case "amazonLowestPrice"                :
						this.downloadAction_amazonLowestPrice(response.data);
						break;
					case "returnApplication"                :
						this.downloadAction_ReturnApplication(response.data);
						break;
					case "getEanByArticleId"                :
						this.downloadAction_getEanByArticleId(response.data);
						break;
					case "getBlockerReasonsForAsin"         :
						this.downloadAction_getBlockerReasonsForAsin(response.data);
						break;
					default                                 :
						alert(`unknown listType action: ${this.select.listType}`);
				}
			}).catch(error => {
				this.showError(error)
			});
		},

		//marketOrderIds
		submitAction_marketOrderIdToCustomerOrder() {
			axios.post("/listmatching", {listInput: this.getListInput(this.extractIds())}) // /action/marketorderid_to_customerorder
					.then(response => {
						this.getAllListmatchingRequest();
						this.queryInProgress = false;
						this.showSuccessToast();
					}).catch(error => {
				this.showError(error)
				console.error(error);
				this.queryInProgress = false;
			});

		},
		downloadAction_marketOrderIdToCustomerOrder(listMatchRequest) {
			const listData = JSON.parse(listMatchRequest.listDataJSON);
			const marketOrderIds = JSON.parse(listMatchRequest.parameterJSON).productIdentifier;

			const mappedOrders = this.mapCustomerOrderData(listData)
			const sortedOrders = this.sortData(marketOrderIds, mappedOrders, 'Bestell-ID');
			console.log(sortedOrders)
			this.generateExcelFile(sortedOrders, 'Kundendaten');
		},

		//shippingId
		submitAction_shippingIdToCustomerOrder() {
			const request = {listInput: this.getListInput(this.extractIds())}
			axios.post('/listmatching', request) ///action/shippingid_to_customerorder
					.then(() => {
						this.getAllListmatchingRequest();
						this.queryInProgress = false;
						this.showSuccessToast();
					}).catch(error => {
				console.error(error);
				this.queryInProgress = false;
				this.showError(error);
			})
		},
		downloadAction_shippingIdToCustomerOrder(listMatchRequest) {
			const listData = JSON.parse(listMatchRequest.listDataJSON);
			const shippingIds = JSON.parse(listMatchRequest.parameterJSON).productIdentifier;
			console.log(listData)
			const mappedOrders = this.mapCustomerOrderData(listData)
			const sortedOrders = this.sortData(shippingIds, mappedOrders, 'Sendungsnummer');
			this.generateExcelFile(sortedOrders, 'Kundendaten');
		},

		//salesInvoice
		submitAction_salesInvoices() {
			const marketOrderIds = this.extractIds();
			axios.post("/listmatching", {listInput: this.getListInput(marketOrderIds)})
					.then(() => {
						this.getAllListmatchingRequest();
						this.queryInProgress = false;
						this.showSuccessToast();
					}).catch(error => {
				console.error(error);
				this.queryInProgress = false;
				this.showError(error);
			})
		},
		downloadAction_salesInvoices(listMatchRequest) {
			const listData = JSON.parse(listMatchRequest.listDataJSON);

			//transforming the B64 encoded zip file to a byte array
			const binaryString = atob(listData);
			const len = binaryString.length;
			const bytes = new Uint8Array(len);
			for (let i = 0; i < len; i++) {
				bytes[i] = binaryString.charCodeAt(i);
			}

			// Create a Blob from the byte array
			const blob = new Blob([bytes], {type: 'application/zip'});
			const url = window.URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = url;
			const date = moment().format('YYYY-MM-DD');
			link.download = `Ausgangsrechnungen${date}.zip`;
			link.click();

			window.URL.revokeObjectURL(url);
			this.queryInProgress = false;
		},

		//articleCondition -- true = new / false = used / null = all
		//onStock -- true = only stock.quantity > 0 / false = only stock.quantity = 0 / null quantity does not matter
		//vendorSelected -- true if vendor(s) were selected / false for tab-divided VendorId and Ean
		//allVendors -- if a list type requires the inventory of all vendors
		submitAction_getInventory(articleCondition, onStock, vendorsSelected, allVendors) {
			const vendorIdBarcodePair = this.extractIds()
			let vendorIds = [];
			const extractedBarcodes = [];
			//logic for tab divided VendorId and Ean
			if (vendorsSelected === false && allVendors === false) {
				for (const row of vendorIdBarcodePair) {
					let dump = row.split("\t");
					extractedBarcodes.push(dump[1]);

					if (dump == "") continue;
					if (dump.length != 2) {
						alert("Haendler-Id und Barcode muessen in jeder Zeile durch ein Tab-Zeichen getrennt werden. Fehlerhafte Zeile: \"" + row + "\"");
						return;
					}

					if (isNaN(dump[0])) {
						alert("Ihre Datenliste enthaelt einen Eintrag, wo der Haendler-Id keine Zahl ist:" + dump[0]);
						return;
					}
					if (isNaN(dump[1])) {
						alert("Ihre Datenliste enthaelt einen Eintrag, wo der EAN keine Zahl ist." + dump[1]);
						return;
					}
				}
			} else {
				if (allVendors === true) {
					vendorIds = this.vendors.filter(vendor => vendor.id !== 99 && vendor.id !== 199 && vendor.id !== 10000).map(vendor => {
						return vendor.id
					})
					vendorIds = vendorIds.sort((a, b) => a - b);
				} else {
					//cloneDeep because then its just a reference and selectedVendors shows subvendors
					vendorIds = _.cloneDeep(this.selectedVendors);
					vendorIds.forEach(id => {
						let tempIds = this.vendors.filter(vendor => vendor.mainVendorId === id).map(vendor => {
							return vendor.id
						});
						tempIds.forEach(tempId => {
							vendorIds.push(tempId);
						})
					})
					vendorIds = vendorIds.sort((a, b) => a - b);
				}
			}

			//convert the Article condition
			if (articleCondition === true) {
				articleCondition = 1;
			} else if (articleCondition === false) {
				articleCondition = 2;
			} else {
				articleCondition = null;
			}

			let request = {
				vendorIds: vendorIds,
				articleCondition: articleCondition,
				onStock: onStock,
				barcodes: extractedBarcodes,
			}

			this.queryInProgress = true;
			axios.post("/listmatching", {listInput: this.getListInput(vendorIdBarcodePair, request)})
					.then(() => {
						this.getAllListmatchingRequest();
						this.queryInProgress = false;
						this.showSuccessToast();
					})
					.catch(error => {
						this.showError(error)
						console.error(error);
						this.queryInProgress = false;
					});
		},
		downloadAction_getInventory(listMatchRequest) {
			const listType = listMatchRequest.listType;
			const listData = JSON.parse(listMatchRequest?.listDataJSON);
			const parameter = JSON.parse(listMatchRequest?.parameterJSON);
			const productIdentifier = parameter.productIdentifier;

			let stocks = listData;
			stocks.forEach(data => {
				if (data.stock) {
					data.stock.vendor = this.vendors.find(v => v.id == Math.max(1, data.stock.vendorId))
				}
			});
			const mappedStocks = stocks.map(data => {
				return {
					originalId: data.originalId,
					Barcode: data.barcode,
					"EK-Preis": data.stock ? parseFloat(data.stock.purchasePrice) : null,
					"EK-Summe": data.stock ? parseFloat(data.stock.purchasePrice) + parseFloat(data.stock?.vendorShippingFee) : null,
					Lieferant: data.stock ? data.stock?.vendor.name : null,
					"Artikel-ID": data.stock?.articleId,
					Lagerbestand: data.stock ? parseInt(data.stock.quantity) : null,
					Eingangsporto: data.stock ? parseFloat(data.stock.vendorShippingFee) : null,
				}
			})


			//Ein Teil des Dateinamen für die jeweilige Funktion
			let operationTypeName = '';
			switch (listType) {
				case "inventoryByEan"                  :
					operationTypeName = 'Inventory_LF-EAN';
					break;
				case "inventoryByEanUsed"              :
					operationTypeName = 'Inventory_LF-EAN_Used';
					break;
				case "inventoryByEanSelectVendor"      :
					operationTypeName = 'Inventory_LF_Auswahl_EAN';
					break;
				case "inventoryByEanUsedSelectVendor"  :
					operationTypeName = 'Inventory_LF_Auswahl_EA_Used';
					break;
				default:
					break;
			}
			let sortedStocks = [];

			sortedStocks = this.sortData(parameter.additionalParameters.barcodes.length > 0 ? parameter.additionalParameters.barcodes : productIdentifier, mappedStocks, 'Barcode')

			this.generateExcelFile(sortedStocks, operationTypeName)
		},

		//articleCondition -- true = new / false = used / null = all
		//onStock -- true = only stock.quantity > 0 / false = only stock.quantity = 0 / null quantity does not matter
		//vendorSelected -- true if vendor(s) were selected / false for tab-divided VendorId and Ean
		//allVendors -- if a list type requires the inventory of all vendors
		submitAction_getCheapestStock(articleCondition, onStock, allVendors) {
			const barcodes = this.extractIds()
			let vendorIds = [];

			if (allVendors === true) {
				vendorIds = this.vendors.filter(vendor => vendor.id !== 99 && vendor.id !== 199 && vendor.id !== 10000).map(vendor => {
					return vendor.id
				})
				vendorIds = vendorIds.sort((a, b) => a - b);
			} else {
				//cloneDeep because then its just a reference and selectedVendors shows subvendors
				vendorIds = _.cloneDeep(this.selectedVendors);
				vendorIds.forEach(id => {
					let tempIds = this.vendors.filter(vendor => vendor.mainVendorId === id).map(vendor => {
						return vendor.id
					});
					tempIds.forEach(tempId => {
						vendorIds.push(tempId);
					})
				})
				vendorIds = vendorIds.sort((a, b) => a - b);
			}
			articleCondition = 1;

			let request = {
				vendorIds: vendorIds,
				articleCondition: articleCondition,
				onStock: onStock,
			}

			this.queryInProgress = true;
			axios.post("/listmatching", {listInput: this.getListInput(barcodes, request)})
					.then(() => {
						this.getAllListmatchingRequest();
						this.queryInProgress = false;
						this.showSuccessToast();
					})
					.catch(error => {
						this.showError(error)
						console.error(error);
						this.queryInProgress = false;
					});
		},
		downloadAction_getCheapestStock(listMatchRequest) {
			const listType = listMatchRequest.listType;
			const listData = JSON.parse(listMatchRequest?.listDataJSON);
			const parameter = JSON.parse(listMatchRequest?.parameterJSON);
			const productIdentifier = parameter.productIdentifier;

			// console.log(listData);
			let stocks = listData;
			stocks?.forEach(data => {
				if (data.stock) {
					data.stock.vendor = this.vendors.find(v => v.id == Math.max(1, data.stock.vendorId))
				}
			});

			const mappedStocks = stocks?.map(data => {
				return {
					originalId: data.originalId,
					Barcode: data.barcode,
					"EK-Preis": data.stock ? parseFloat(data.stock.purchasePrice) : null,
					"EK-Summe": data.stock ? parseFloat(data.stock.purchasePrice) + parseFloat(data.stock?.vendorShippingFee) : null,
					Lieferant: data.stock ? data.stock?.vendor.name : null,
					"Artikel-ID": data.stock?.articleId,
					Lagerbestand: data.stock ? parseInt(data.stock.quantity) : null,
					Eingangsporto: data.stock ? parseFloat(data.stock.vendorShippingFee) : null,
				}
			})

			//Ein Teil des Dateinamen für die jeweilige Funktion
			let operationTypeName = '';
			switch (listType) {
				case "cheapestWithStock"               :
					operationTypeName = 'Günstigster_mit_Bestand';
					break;
				case "cheapestWithStock_AllVendors"    :
					operationTypeName = 'Günstigster_mit_Bestand';
					break;
				case "cheapestWithoutStock"            :
					operationTypeName = 'Günstigster_ohne_Bestand';
					break;
				case "cheapestWithoutStock_AllVendors" :
					operationTypeName = 'Günstigster_ohne_Bestand';
					break;
				default:
					break;
			}

			const sortedStocks = this.sortGetWeightData(productIdentifier, mappedStocks, 'Barcode')
			this.generateExcelFile(sortedStocks, operationTypeName)
			this.queryInProgress = false;
		},

		submitAction_getLastSellingPrice() {
			this.queryInProgress = true;
			axios.post('listmatching', {listInput: this.getListInput(this.extractIds())})
					.then(() => {
						this.getAllListmatchingRequest();
						this.queryInProgress = false;
						this.showSuccessToast();
					})
					.catch(error => {
						console.log(error);
						this.queryInProgress = false;
						this.showError(error)
					});
		},
		downloadAction_getLastSellingPrice(listMatchRequest) {
			const listData = JSON.parse(listMatchRequest?.listDataJSON);
			const parameter = JSON.parse(listMatchRequest?.parameterJSON);
			const productIdentifier = parameter.productIdentifier;

			const mappedData = listData.map(data => {
				return {
					originalId: data.originalId,
					Barcode: data.barcode,
					"VK-Preis €": data.customerOrder ? (Number(data.customerOrder?.articlePriceClear) * Number(data.customerOrder?.currencyToEuro)).toFixed(2) : null,
					KaufDatum: data.customerOrder?.orderTime,
					SKU: data.customerOrder?.sku,
					"Bestell-Nr.": data.customerOrder?.marketOrderId,
					Artikelname: data.customerOrder?.articleTitle,
				}
			})

			const sortedData = this.sortData(productIdentifier, mappedData, 'Barcode')
			this.generateExcelFile(sortedData, 'Letzter_VK-Preis');
		},

		submitAction_getShippingWeight(_isEan) {
			this.queryInProgress = true;
			axios.post('listmatching', {listInput: this.getListInput(this.extractIds(), {isEan: _isEan})})
					.then(() => {
						this.getAllListmatchingRequest();
						this.queryInProgress = false;
						this.showSuccessToast();
					})
					.catch(error => {
						console.log(error);
						this.queryInProgress = false;
						this.showError(error)
					});
		},
		downloadAction_getShippingWeight(listMatchRequest) {
			//with this the order of columns is dynamically set
			const listData = JSON.parse(listMatchRequest?.listDataJSON);
			const parameter = JSON.parse(listMatchRequest?.parameterJSON);
			const productIdentifier = parameter.productIdentifier;
			const _isEan = parameter.additionalParameters.isEan;

			let keyToSort = null;
			let keyNotToSort = null;
			if (_isEan) {
				keyToSort = 'EAN';
				// keyNotToSort = 'ASIN';
			} else {
				keyToSort = 'ASIN';
				// keyNotToSort = 'EAN';
			}

			const mappedMaterials = listData.map(material => {
				return {
					originalId: material.originalId,
					'EAN': material.materialData?.ean ?? material?.ean,
					'ASIN': material.materialData?.asin ?? material?.asin,
					MaterialId: material.materialData?.id,
					"Gewicht [KG]": material.materialData?.product ? (material.materialData.product.shippingWeight / 1000) : '',
					Kategorie: material.materialData?.product ? this.getCategoryName(material.materialData.product.category) : '',
					Produktname: material.materialData?.product ? material.materialData.product.name : '',

				}
			});

			let sortedMaterial = [];
			sortedMaterial = this.sortGetWeightData(productIdentifier, mappedMaterials, keyToSort)
			this.generateExcelFile(sortedMaterial, 'LA-Gewicht')
		},

		submitAction_quantityOfSales() {
			let vendorIds = [];

			if (this.selectedVendors.length !== 0) {

				vendorIds = _.cloneDeep(this.selectedVendors);
				vendorIds.forEach(id => {
					let tempIds = this.vendors.filter(vendor => vendor.mainVendorId === id).map(vendor => {
						return vendor.id
					});
					tempIds.forEach(tempId => {
						vendorIds.push(tempId);
					})
				})
				vendorIds = vendorIds.sort((a, b) => a - b);
			}

			this.queryInProgress = true;
			axios.post('listmatching', {listInput: this.getListInput(this.extractIds())}).then(() => {
				this.getAllListmatchingRequest();
				this.queryInProgress = false;
				this.showSuccessToast();
			}).catch(error => {
				console.error(error);
				this.queryInProgress = false;
				this.showError(error)
			});

		},
		downloadAction_quantityOfSales(listMatchRequest) {
			const listData = JSON.parse(listMatchRequest?.listDataJSON);
			const parameter = JSON.parse(listMatchRequest?.parameterJSON);
			const productIdentifier = parameter.productIdentifier;

			const mappedstocks = listData.map(stock => {
				return {
					originalId: stock[0].originalId,
					EAN: stock[0].barcode,
					Name: stock[0].materialName,
					MaterialId: stock[0].materialId,
					"Verkaufshäufigkeit": stock[0].salesCount,
					Artikelnummer: stock[0].articleId,
					Lieferant: stock[0].bestStock?.vendor.name,
					SKU: stock[0].bestStock?.sku,
					purchasePrice: stock[0].bestStock?.purchasePrice,
					"Lagerbestand": stock[0].bestStock?.quantity,
					InStockSince: stock[0].bestStock?.inStockSince,
					lastUpdateTime: stock[0].bestStock?.lastUpdateTime,
					lastUpdateUser: stock[0].bestStock?.lastUpdateUser,
					lastUpdateReason: stock[0].bestStock?.lastUpdateReason,
					"letzter Verkauf": stock[0].lastSale,

				}
			})

			const sortedStocks = this.sortData(productIdentifier, mappedstocks, 'EAN');
			this.generateExcelFile(sortedStocks, 'Verkaufshäufigkeit');
		},

		submitAction_amazonLowestPrice() {
			this.queryInProgress = true;
			axios.post('/listmatching', {listInput: this.getListInput(this.extractIds())})
					.then(() => {
						this.getAllListmatchingRequest();
						this.queryInProgress = false;
						this.showSuccessToast();
					}).catch(error => {
				this.queryInProgress = false;
				this.showError(error)
			});
		},
		downloadAction_amazonLowestPrice(listMatchRequest) {
			const listData = JSON.parse(listMatchRequest?.listDataJSON);
			const parameter = JSON.parse(listMatchRequest?.parameterJSON);
			const productIdentifier = parameter.productIdentifier;

			const mappedData = listData.map(data => {

				return {
					originalId: data.originalId,
					Barcode: data.ean,
					ASIN: data.asin,
					"US-Amazon-Gesamtpreis (€)": this.convertPriceToEuro(this.getLowestPrice(data, 'AMZ-US', 'Amazon')?.LandedPrice?.Amount,
							this.getLowestPrice(data, 'AMZ-US', 'Amazon')?.LandedPrice?.CurrencyCode),
					"US-Händler-Gesamtpreis (€)": this.convertPriceToEuro(this.getLowestPrice(data, 'AMZ-US', 'Merchant')?.LandedPrice?.Amount,
							this.getLowestPrice(data, 'AMZ-US', 'Merchant')?.LandedPrice?.CurrencyCode),
					"US-Verkaufsranking-Kat.": data?.marketData?.["AMZ-US"]?.SalesRankings?.[0]?.ProductCategoryId
							? data.marketData["AMZ-US"].SalesRankings[0].ProductCategoryId.split("_")[0]
							: null,
					"US-Verkaufsranking": data?.marketData?.["AMZ-US"]?.SalesRankings?.[0]?.Rank,

					"UK-Amazon-Gesamtpreis (€)": this.convertPriceToEuro(this.getLowestPrice(data, 'AMZ-UK', 'Amazon')?.LandedPrice?.Amount,
							this.getLowestPrice(data, 'AMZ-UK', 'Amazon')?.LandedPrice?.CurrencyCode),
					"UK-Händler-Gesamtpreis (€)": this.convertPriceToEuro(this.getLowestPrice(data, 'AMZ-UK', 'Merchant')?.LandedPrice?.Amount,
							this.getLowestPrice(data, 'AMZ-UK', 'Merchant')?.LandedPrice?.CurrencyCode),
					"UK-Verkaufsranking-Kat.": data?.marketData?.["AMZ-UK"]?.SalesRankings?.[0]?.ProductCategoryId
					? data.marketData["AMZ-UK"].SalesRankings[0].ProductCategoryId.split("_")[0]
					: null,
					"UK-Verkaufsranking": data?.marketData?.["AMZ-UK"]?.SalesRankings?.[0]?.Rank,

					"DE-Amazon-Gesamtpreis (€)": this.convertPriceToEuro(this.getLowestPrice(data, 'AMZ-DE', 'Amazon')?.LandedPrice?.Amount,
							this.getLowestPrice(data, 'AMZ-DE', 'Amazon')?.LandedPrice?.CurrencyCode),
					"DE-Händler-Gesamtpreis (€)": this.convertPriceToEuro(this.getLowestPrice(data, 'AMZ-DE', 'Merchant')?.LandedPrice?.Amount,
							this.getLowestPrice(data, 'AMZ-DE', 'Merchant')?.LandedPrice?.CurrencyCode),
					"DE-Verkaufsranking-Kat.": data?.marketData?.["AMZ-DE"]?.SalesRankings?.[0]?.ProductCategoryId
					? data.marketData["AMZ-DE"].SalesRankings[0].ProductCategoryId.split("_")[0]
					: null,
					"DE-Verkaufsranking": data?.marketData?.["AMZ-DE"]?.SalesRankings?.[0]?.Rank,

					"CA-Amazon-Gesamtpreis (€)": this.convertPriceToEuro(this.getLowestPrice(data, 'AMZ-CA', 'Amazon')?.LandedPrice?.Amount,
							this.getLowestPrice(data, 'AMZ-CA', 'Amazon')?.LandedPrice?.CurrencyCode),
					"CA-Händler-Gesamtpreis (€)": this.convertPriceToEuro(this.getLowestPrice(data, 'AMZ-CA', 'Merchant')?.LandedPrice?.Amount,
							this.getLowestPrice(data, 'AMZ-CA', 'Merchant')?.LandedPrice?.CurrencyCode),
					"CA-Verkaufsranking-Kat.": data?.marketData?.["AMZ-CA"]?.SalesRankings?.[0]?.ProductCategoryId
					? data.marketData["AMZ-CA"].SalesRankings[0].ProductCategoryId.split("_")[0]
					: null,
					"CA-Verkaufsranking": data?.marketData?.["AMZ-CA"]?.SalesRankings?.[0]?.Rank,

					"ES-Amazon-Gesamtpreis (€)": this.convertPriceToEuro(this.getLowestPrice(data, 'AMZ-ES', 'Amazon')?.LandedPrice?.Amount,
							this.getLowestPrice(data, 'AMZ-ES', 'Amazon')?.LandedPrice?.CurrencyCode),
					"ES-Händler-Gesamtpreis (€)": this.convertPriceToEuro(this.getLowestPrice(data, 'AMZ-ES', 'Merchant')?.LandedPrice?.Amount,
							this.getLowestPrice(data, 'AMZ-ES', 'Merchant')?.LandedPrice?.CurrencyCode),
					"ES-Verkaufsranking-Kat.": data?.marketData?.["AMZ-ES"]?.SalesRankings?.[0]?.ProductCategoryId
					? data.marketData["AMZ-ES"].SalesRankings[0].ProductCategoryId.split("_")[0]
					: null,
					"ES-Verkaufsranking": data?.marketData?.["AMZ-ES"]?.SalesRankings?.[0]?.Rank,
				}
			});
			const sortedData = this.sortData(productIdentifier, mappedData, 'Barcode');
			this.generateExcelFile(sortedData, 'Amazon niedrigster Preis (EAN)');
		},

		submitAction_ReturnApplication() {
			const extractedBarcodes = [];
			const barcodeAndQuantityPair = [];
			for (const row of this.extractIds()) {
				let dump = row.split("\t");
				if (dump == "") continue;
				if (dump.length !== 2) {
					alert("Ean und Menge muessen in jeder Zeile durch ein Tab-Zeichen getrennt werden. Fehlerhafte Zeile: \"" + row + "\"");
					return;
				}
				if (isNaN(dump[0])) {
					alert("Die Datenliste enthaelt einen Eintrag, wo der EAN keine Zahl ist:" + dump[0]);
					return;
				}
				if (isNaN(dump[1])) {
					alert("Ihre Datenliste enthaelt einen Eintrag, wo die keine Zahl ist." + dump[1]);
					return;
				}
				extractedBarcodes.push(dump[0]);
				barcodeAndQuantityPair.push({
					barcode: dump[0],
					quantity: dump[1]
				})
			}
			console.log({listInput: this.getListInput(barcodeAndQuantityPair)})
			this.queryInProgress = true;
			axios.post('listmatching', {listInput: this.getListInput(barcodeAndQuantityPair)}).then(() => {
				this.getAllListmatchingRequest();
				this.queryInProgress = false;
				this.showSuccessToast();
			}).catch(error => {
				console.error(error);
				this.queryInProgress = false;
				this.showError(error)
			});
		},
		downloadAction_ReturnApplication(listMatchRequest) {
			const listData = JSON.parse(listMatchRequest?.listDataJSON);
			const parameter = JSON.parse(listMatchRequest?.parameterJSON);
			const productIdentifier = parameter.productIdentifier;

			console.log(productIdentifier);
			const sortedIds = productIdentifier.map(item => {
				const match = listData?.find(data => data.material?.originalEan === item['barcode']);
				return match ? match.material.ean : null;
			});
			console.log(sortedIds);
			let mappedReturnRequestData = listData.map(data => {
				return {
					Ean: data?.material?.ean,
					"ArticleId": data?.material?.articleId,
					"Name": data?.material?.product?.name,
					"EK in Euro": data?.purchasePrice,
					"Verkaufshäufigkeit.": data?.salesCount,
					deliveryNotes: data?.deliveryNotes
				}
			})
			mappedReturnRequestData = mappedReturnRequestData.map(data => {
				if (!data.deliveryNotes) return data;
				data.deliveryNotes.forEach(((dn, index) => {
					data[`Rechung_${index + 1}`] =  `RE_Number: ${dn.dnNumber} - RE_Menge: ${dn.quantity} - RE_Datum: ${moment(dn.dnDate).format("DD-MM-YYYY")} - Dateiname: ${dn.fileName}`;
				}))
				delete data.deliveryNotes;
				return data;
			})
			// past logic for sorted Ids `.length > 1 ? sortedIds : extractedBarcodes`
			const sortedReturnRequestData = this.sortReturnApplicationIds(sortedIds, mappedReturnRequestData, 'Ean');
			console.log(sortedReturnRequestData)
			this.generateExcelFile(sortedReturnRequestData, 'Retourenantrag');
			this.queryInProgress = false;
		},

		submitAction_getEanByArticleId() {
			this.queryInProgress = true;
			axios.post('listmatching', {listInput: this.getListInput(this.extractIds())})
					.then(() => {
						this.getAllListmatchingRequest();
						this.queryInProgress = false;
						this.showSuccessToast();
					}).catch(error => {
				console.error(error);
				this.queryInProgress = false;
				this.showError(error)
			});
		},
		downloadAction_getEanByArticleId(listMatchRequest) {
			const listData = JSON.parse(listMatchRequest?.listDataJSON);
			const parameter = JSON.parse(listMatchRequest?.parameterJSON);
			const productIdentifier = parameter.productIdentifier;

			const mappedData = listData.map(data => {
				return {
					"originalId": data.articleId,
					"Artikel-ID": data.articleId,
					"Lieferant": data.vendorId ? this.vendors.find(v => v.id === data.vendorId)?.name : null,
					EAN: data.ean,
					SKU: data.sku,
				}
			})

			const sortedData = this.sortData(productIdentifier, mappedData, 'Artikel-ID')
			this.generateExcelFile(sortedData, 'ArtikelId zu EAN');
		},

		submitAction_getBlockerReasonsForAsin() {
			this.queryInProgress = true;
			axios.post('listmatching', {listInput: this.getListInput(this.extractIds())})
					.then(() => {
						this.getAllListmatchingRequest();
						this.queryInProgress = false;
						this.showSuccessToast();
					}).catch(error => {
				console.error(error);
				this.queryInProgress = false;
				this.showError(error)
			});
		},
		downloadAction_getBlockerReasonsForAsin(listMatchRequest) {
			const listData = JSON.parse(listMatchRequest?.listDataJSON);
			const parameter = JSON.parse(listMatchRequest?.parameterJSON);
			const productIdentifier = parameter.productIdentifier;
			const mappedData = listData.map(data => {
				let row = {
					originalId: data.originalId,
					ASIN: data.asin
				};

				// 2. Dynamically add all reason_x and country_x keys present in the data
				Object.keys(data).forEach(key => {
					if (key.startsWith('reason_')) {
						const num = key.split('_')[1];
						row[`Sperrgrund ${num}`] = data[key];
					} else if (key.startsWith('country_')) {
						const num = key.split('_')[1];
						row[`Länder-ISO ${num}`] = data[key];
					}
				});

				return row;
			});
			const sortedData = this.sortData(productIdentifier, mappedData, 'ASIN')
			this.generateExcelFile(sortedData, 'Blockiergründe zu ASINs');
		},

		convertPriceToEuro(price, currencyCode) {
			const currency = this.currencies.find(c => c.code === currencyCode);
			if (!currency || !price) return null;

			return (price * currency.rate).toFixed(2);
		},

		getLowestPrice(data, amazonMarket, seller) {
			if (!(data?.marketData?.[amazonMarket])) return null;
			return data.marketData[amazonMarket]?.LowestPrices?.find(elem => elem?.Condition === "new" && elem?.FulfillmentChannel === seller);
		},

		getCategoryName(category) {
			return this.categoryMap[category]?.name || "Unbekannt";
		},

		getHSCode(category) {
			return this.categoryMap[category]?.hs6Code || "000000";
		},

		generateExcelFile(mappedData, fileName) {
			let currentDate = moment().format("DD.MM.YYYY");
			Vue.nextTick().then(() => {
				const ws = XLSX.utils.json_to_sheet(mappedData);
				const wb = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, ws);
				XLSX.writeFile(wb, fileName + '-' + currentDate + ".xlsx");
			})
		},

		showError(error) {
			this.modalError = {
				show: true,
				message: "Operation konnte nicht durgeführt werden.",
				error: error.name + ": " + error.message + "\n" + error.response?.data?.message + "\n" + error.stack,
				title: "Ein Fehler ist aufgetreten"
			};
		},

		extractIds() {
			//split the barcodes by line break and trim each line,
			// remove empty rows containing only a double quote, probably due hidden line break in excel cell
			// and remove all single and double quotes from the ids
			return this.select.barcodes.split('\n').filter(s => s.trim() !== '"').map(s => s.replaceAll("'", '').replaceAll('"', '').trim())
		},
		sortData(idsArray, dataArray, keyToSortName){
			console.log(idsArray, dataArray, keyToSortName)
			const isAsinKey = keyToSortName.toLowerCase() === 'asin';

				let sortedArray = [];
				idsArray.forEach(id => {
					const searchId = isAsinKey ? String(id).trim() : id;
					let maybe = dataArray.find(data => searchId == data?.originalId);
					if (!maybe) {
						maybe = {
							[keyToSortName]: searchId
						}
					} else {
						maybe = { ...maybe }; // clone first so we don’t modify original
						// for dev only purpose
/*						if(maybe[keyToSort] === undefined){
							maybe[keyToSort] = id;
						}*/
					}
					delete maybe.originalId;

					sortedArray.push(maybe);
				});
			console.table(sortedArray)
				return sortedArray;
		},
		sortReturnApplicationIds(idsArray, dataArray, keyToSort) {
			let sortedArray = [];
			idsArray.forEach(id => {
				let maybe = dataArray.find(data => id == data[keyToSort]);

				if (!maybe) {
					maybe = {
						[keyToSort]: id
					}
				}

				sortedArray.push(maybe);
			});

			return sortedArray;
		},

		//sorts dataArray by the order of idsArray, keyToSort is the key in dataArray to match with idsArray
		sortGetWeightData(idsArray, dataArray, keyToSort) {
			console.log(idsArray, dataArray, keyToSort)
			return idsArray.map(id => {
				if (id === undefined || id === null || String(id).trim() === '') {
					return {
						[keyToSort]: '',
					};
				}

				const searchId = String(id).trim();

				const match = (dataArray ?? []).find(data => {
					if (data?.originalId === undefined || data?.originalId === null || String(data.originalId).trim() === '') {
						return false;
					}

					return String(data.originalId).trim() === searchId;
				});

				//if no match is found, return an object with the searched id to at least have it in the file
				if (!match) {
					return {
						[keyToSort]: searchId,
					};
				}

				//if the key to sort is empty in the match, also return the searched id to have it in the file and not lose it
				if (match[keyToSort] === undefined || match[keyToSort] === null || String(match[keyToSort]).trim() === '') {
					return {
						[keyToSort]: searchId,
					};
				}

				const row = { ...match };
				delete row.originalId;

				return row;
			});
		},

		//sorts dataArray by the order of idsArray, keyToSort is the key in dataArray to match with idsArray
		//maps the CustomerOrders for MarketOrderId/ShippingId
		mapCustomerOrderData(customerOrders) {

			return customerOrders.map(customerOrder => {

				customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime = null;
				customerOrder.isVendorChange = false;
				customerOrder.isReorder = false;
				// console.log("+++ called compileCustomerOrder");
				for (let h of customerOrder.customerorderhistories) {
					if ((h.lastUpdateReason && h.lastUpdateReason.includes('Delivery Job'))
							&& (customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime == null
									|| customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime > null)) {
						customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime = h.lastUpdateTime; // aka Meldedatum
					}
					customerOrder.isVendorChange = customerOrder.isVendorChange || (h.comment && h.comment.includes("Umbestellung"));
					customerOrder.isReorder = customerOrder.isReorder || (h.comment && h.comment.includes("Neubestellung"));

				}
				//if, by chance, the Marketplace is Priceminister (3) and no 'Delivery Job' History exists, just use the COID.submissionTime
				if (['0000-00-00 00:00:00', '1999-11-30 00:00:00', '', null, undefined].includes(customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime)
						&& customerOrder.marketAccountId == 3 /*DANGER*/) {
					//marvelous, truly
					customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime = customerOrder.customerorderitems[0]
							.customerorderitemdeliveries[0]
							.deliverySubmissionTime;
				}

				let tracking = "";
				if (customerOrder.customerorderitems[0]?.customerorderitemdeliveryaddition) {
					tracking = customerOrder.customerorderitems[0]?.customerorderitemdeliveryaddition?.shippingId
				}

				return {
					originalId: customerOrder.originalId,
					CustomerOrderID: customerOrder.id,
					Marketaccount: customerOrder.marketaccount.name,
					Kaufdatum: customerOrder.paymentDate,
					SKU: customerOrder.customerorderitems[0]?.stock.sku,
					EAN: customerOrder.customerorderitems[0]?.stock.material.ean,
					"Bestell-ID": customerOrder.marketOrderId,
					MarketOrderItemID: customerOrder.customerorderitems[0]?.marketOrderItemId,
					Vorversanddatum: customerOrder.lastUpdateTime,
					Meldedatum: customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime,
					Versanddatum: customerOrder.deliveryDate,
					Kategorie: this.getCategoryName(customerOrder.customerorderitems[0]?.product?.category),
					Artikelname: customerOrder.customerorderitems[0]?.product?.name,
					Anzahl: customerOrder.customerorderitems[0]?.quantity,
					Gesamtpreis: customerOrder.customerorderitems[0]?.articlePriceGross,
					Empfaengername: `${customerOrder.address.firstname == undefined ? "" : customerOrder.address.firstname} ${customerOrder.address.lastName}`,
					"Kunden-Email": customerOrder.address.email,
					Adresse1: customerOrder.address.street,
					Adresse2: customerOrder.address.street2,
					Stadt: customerOrder.address.city,
					PLZ: customerOrder.address.zipCode,
					Staat: customerOrder.address.state,
					Land: customerOrder.address.country.countryName,
					Sendungsnummer: tracking,
					Gesamtartikelpreis: customerOrder.customerorderitems[0]?.articlePriceClear,
					HScode: this.getHSCode(customerOrder.customerorderitems[0]?.product?.category),
					ArtikelGewicht: customerOrder.customerorderitems[0]?.product?.baseWeight,
				}
			})
		},

		getListInput(productIdentifiers, additionalParameters = null) {
			let parameters = {
				vendorIds: this.listRequiresVendorSelectionInput ? this.selectedVendors : null,
				date: this.listRequiresDatePickerInput || this.listRequiresSingleDatePickerInput ? {
					from: this.dateFrom,
					to: this.dateTo
				} : null,
				productIdentifier: productIdentifiers,
				additionalParameters: additionalParameters,
			}
			return {
				listType: this.select.listType,
				parameters: parameters,
			}
		},
		translateListType(listType) {
			if (listType === null || listType === undefined) return;
			return this.listTypeOptions.find(option => option.value === listType)?.text;
		},
		getVendorName(vendorId) {
			if (!this.vendors) return;
			return this.vendors.find(vendor => vendor.id === Math.max(1, vendorId))?.name;
		},
		rowClass(item) {
			if (item.errorJSON) {
				return 'table-danger';
			} else {
				return 'bg-test';
			}
			// return item.errorJSON?.message != null ? 'bg-error' : 'bg-test';
		},
		disableDownloadButton(item) {
			return item.completedAt == null;
		},
		showSuccessToast() {
			this.$bvToast.toast('Liste wurde erfolgreich angefragt', {
				title: 'Erfolg',
				variant: 'success',
				solid: true
			})
		},
		getUser() {
			axios.get('/user/self')
					.then(response => {
						this.userRole = response.data.role;
					})
					.catch(error => {
						console.error("Error fetching user data:", error);
					});
		},
		handleVisibilityChange() {
			this.tabIsActive = !document.hidden;

			if (this.tabIsActive) {
				console.log('Tab is active again');
			} else {
				console.log('Tab is inactive');
			}
		},
	},

	created() {
		this.getAllVendors();
		this.getAllListmatchingRequest();
		this.getAllCurrencies();
		this.getUser();

		Object.values(this.productCategories).map(category => {
			this.categoryMap[category.categoryId] = {
				name: category.uiName,
				hs6Code: category.hs6,
				hs10Code: category.hs10
			}
		});
	},
	mounted() {
		document.addEventListener('visibilitychange', this.handleVisibilityChange);

		this.reloadInterval = setInterval(() => {
			if(!this.tabIsActive) {
				console.log('Tab is inactive, skipping data refresh');
				return;
			}
			this.getAllListmatchingRequest();
		}, 30000); // every 30 seconds
	},
	beforeUnmount() {
		document.removeEventListener('visibilitychange', this.handleVisibilityChange);

		if (this.reloadInterval) {
			clearInterval(this.reloadInterval);
		}
	}
};
</script>
<style scoped>
:deep(.multiselect__tags) {
	min-height: 28px;
	font-size: 0.7875rem;
}
</style>
